<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-layout row wrap>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg3>
        <v-select
          v-model="formasDePagamento"
          :items="formasPagamento"
          label="Formas de pagamento"
          multiple
          attach
          outlined
          dense
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark @click="carregaDados" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"    
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando pedidos..."
          show-expand
          single-expand
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">Pedidos</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
            <v-card v-for="pedido in item.itensPedido" :key="pedido.produtoId" tile outlined>
              <v-row>
                <!-- <v-col sm="2" md="2" lg="2" xs="2" xl="2" style="text-align: center;" align-self="center">
                  <v-avatar size="90px" tile class="ma-2">
                    <v-img style="border-radius: 15px;" :src="pedido.urlImagem"></v-img>
                  </v-avatar>  
                </v-col>  -->
                <v-col sm="7" md="7" lg="7" xs="7" xl="7" align-self="center">
                  <v-card-title
                    class="text-h6"
                    v-text="pedido.descricao"
                    style="font-weight: bold; color: #37474F;"
                  ></v-card-title>
                  <v-card-subtitle v-text="pedido.detalhes"></v-card-subtitle>
                  <v-card-text v-if="pedido.observacao" v-text="'Obs: ' + pedido.observacao"></v-card-text>
                  <v-card-actions v-if="pedido.adicionais">Adicionais:
                    <v-chip dark v-for="adc in pedido.adicionais" :key="adc.produtoId" color="#0277BD" class="ma-2">{{adc.descricao + ' R$ ' + adc.preco  + ' ' + adc.quantidade + 'un'}}</v-chip>
                  </v-card-actions>
                </v-col>
                <v-col sm="3" md="3" lg="3" xs="3" xl="3" align-self="center" style="text-align: center;">
                  <v-card-subtitle style="padding-top: 1px;padding-bottom: 1px;">Valor</v-card-subtitle>    
                  <h2 style="padding-top: 1px;padding-bottom: 1px;color: #00BFA5;font-weight: bold;">R$ {{pedido.preco}}</h2>  
                  <v-row justify="center">    
                    <v-subheader style="font-weight: bold; font-size: 22px;">{{pedido.quantidade == undefined ? 0 : pedido.quantidade + 'un'}}</v-subheader>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            </td>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Nenhum pedido encontrado</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="body.append">
            <tr>
              <td :colspan="tabela.cabecalho.length">
                <h2 style="margin: 0 auto; text-align: center">Total: {{ campoSoma('valor') }}</h2>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            R$ {{ item.valor }}
          </template>
          <template v-slot:[`item.created`]="{ item }">
            {{ formatDateHour(item.created) }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Nº', value: 'numero', align: 'start' },
          { text: 'Status', value: 'statusPedido' },
          { text: 'Forma de Pagamento', value: 'formaPagamento' },
          { text: 'Status Pagamento', value: 'statusPagamento' },
          { text: 'Valor', value: 'valor' },
          { text: 'Desconto', value: 'desconto' },
          { text: 'Data Pedido', value: 'created' },
          { text: 'Detalhes', value: 'data-table-expand' },
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndexCat: -1,
      editedIndexProd: -1,
      formasPagamento: ['CREDITO','DEBITO','DINHEIRO','PIX'],
      formasDePagamento: ['CREDITO','DEBITO','DINHEIRO','PIX']
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },  
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted () {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        this.tabela.carregamento = true
        this.tabela.conteudo = []
        let whereor = '['
        for (let i = 0; i < this.formasDePagamento.length; i++) {
          whereor += '{"formaPagamento":"' + this.formasDePagamento[i].toString() + '"}'
          if (i < (this.formasDePagamento.length - 1)) {
            whereor += ','
          }
        }
        whereor += ']'
        await axios.get(`${baseApiUrl}Pedidos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"},{"or":${whereor}},{"created":{"gt":"${this.dataInicio}T${this.horaInicio}:00.000Z"}},{"created":{"lt":"${this.dataFim}T${this.horaFim}:00.000Z"}}]}}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(response => {
          this.tabela.conteudo = response.data
          this.tabela.carregamento = false
        })      
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },

      campoSoma(key) {
        // sum data in give key (property)
        return 'R$ ' + this.tabela.conteudo.reduce((a, b) => (parseFloat(a) + parseFloat(b[key])).toFixed(2), 0)
      },
      
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
